// action customization
export const SET_ERROR = 'SET_ERROR'; 

export const SET_MENU = '@customization/SET_MENU';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';

// actions  user

export const SAVE_USER = 'SAVE_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';

export const SAVE_TOP_FILTER_VALUES = 'SAVE_TOP_FILTER_VALUES';
export const GET_TOP_FILTER_VALUES = 'GET_TOP_FILTER_VALUES';
export const REMOVE_TOP_FILTER_VALUES = 'REMOVE_TOP_FILTER_VALUES';

export const SAVE_ORDERS = 'SAVE_ORDERS';
export const GET_ORDER = 'GET_ORDER';

export const ADD_OPTION_CHAIN_INSTRUMENTS = 'SAVE_ADD_OPTION_CHAIN_INSTRUMENTSORDERS';
export const GET_OPTION_CHAIN_INSTRUMENTS = 'GET_OPTION_CHAIN_INSTRUMENTS';

export const ADD_BASKET = 'ADD_BASKET';
export const GET_BASKET = 'GET_BASKET';
export const REMOVE_BASKET = 'REMOVE_BASKET';

export const SAVE_SOCKET_JWT_TOKEN = 'SAVE_SOCKET_JWT_TOKEN';
export const SAVE_TRADE_FEED_SOURCE = 'SAVE_TRADE_FEED_SOURCE';
export const SAVE_SOCK_SOURCE = 'SAVE_SOCK_SOURCE';
export const SAVE_POSITION = 'SAVE_POSITION';
export const SAVE_WINDOW_SCREEN = 'SAVE_WINDOW_SCREEN';

export const SAVE_MARGIN = 'SAVE_MARGIN';
export const SAVE_FUNDS = 'SAVE_FUNDS';

export const SAVE_POSITION_TOKEN = 'SAVE_POSITION_TOKEN';
export const REMOVE_POSITION_TOKEN = 'REMOVE_POSITION_TOKEN';
export const IS_ORDER_FIRED = 'IS_ORDER_FIRED';

export const SAVE_INSTRUMENT_CONFIG = "SAVE_INSTRUMENT_CONFIG"
export const SAVE_STRIKE_DATA = "SAVE_STRIKE_DATA"

export const SAVE_INSTRUMENT_EXPIRY = "SAVE_INSTRUMENT_EXPIRY"
export const SAVE_INSTRUMENT_SPOT_PRICE = "SAVE_INSTRUMENT_SPOT_PRICE"
export const SAVE_OP_TICK_DATA = "SAVE_OP_TICK_DATA"
export const SAVE_SYN_FUT_PRICE = "SAVE_SYN_FUT_PRICE"
export const SAVE_FUT_PRICE = "SAVE_FUT_PRICE"

export const SAVE_SYN_FUT_TOKEN = "SAVE_SYN_FUT_TOKEN"

export const SET_SUSCRIPTIONS = "SET_SUSCRIPTIONS"
export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';
export const SAVE_MIDDLE_STRIKE = "SAVE_MIDDLE_STRIKE"
export const SAVE_POSITION_MARGE = "SAVE_POSITION_MARGE"
export const SAVE_QUIK_KEY = "SAVE_QUIK_KEY"
export const STRATEGY_GROPING= "STRATEGY_GROPING"
export const SAVE_BASKET_SLTP= "SAVE_BASKET_SLTP"
export const SAVE_BROKER_SLTP= "SAVE_BROKER_SLTP"

export const FETCH_PACKAGES = "FETCH_PACKAGES"
export const SET_PACKAGES_LIST = "SET_PACKAGES_LIST"
export const SET_APPLY_PROMOCODE = "SET_APPLY_PROMOCODE"
export const SET_SUSCRIPTION_ORDER_ID = "SET_SUSCRIPTION_ORDER_ID"
export const SET_SUSCRIPTION_STATUS = "SET_SUSCRIPTION_STATUS"
export const CLEAR_SUSCRIPTION_STATUS = "CLEAR_SUSCRIPTION_STATUS"
export const SESSION_EXPIRED = "SESSION_EXPIRED"
export const SET_LOGIN_CHECK = "SET_LOGIN_CHECK"
// brokers
export const SAVE_BROKERS_LIST = "SAVE_BROKERS_LIST"